var mixin = {
  data () {
    return {
      isDirty: false
    }
  },
  methods: {
    onChangesSaved: function () {
      this.isDirty = false
    },
    onChangesCancelled: function () {
      this.isDirty = false
    },
    onFormChange: function () {
      this.isDirty = true
    },
    checkDirty: function (next) {
      if (this.isDirty) {
        if (confirm('You have un-saved changes. Do you wish to discard these changes?')) {
          next()
        }
      } else {
        next()
      }
    },
    validateBeforeSubmit () {
      if (this.serverErrors) {
        this.serverErrors = []
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.onSave()
        } else {
          if (this.onValidationFailure) {
            this.onValidationFailure()
          }
          document.querySelectorAll('.header-collapsed').forEach((x) => x.classList.remove('header-collapsed'))
          this.$goToFirstValidationError(this.$validator.errors.items)
        }
      })
    },
    validateBeforeSubmitWithCallBack (onSave) {
      if (this.serverErrors) {
        this.serverErrors = []
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (onSave) {
            onSave()
          } else {
            this.onSave()
          }
        } else {
          document.querySelectorAll('.header-collapsed').forEach((x) => x.classList.remove('header-collapsed'))
          this.$goToFirstValidationError(this.$validator.errors.items)
        }
      })
    },
    validateBeforeSubmitScoped (scope) {
      if (this.serverErrors) {
        this.serverErrors = []
      }
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.onSave()
        } else {
          document.querySelectorAll('.header-collapsed').forEach((x) => x.classList.remove('header-collapsed'))
          this.$goToFirstValidationError(this.$validator.errors.items)
        }
      })
    },
    validateBeforeSubmitAllScoped () {
      if (this.serverErrors) {
        this.serverErrors = []
      }

      this.$validator.validateScopes().then((result) => {
        if (result) {
          this.onSave()
        } else {
          // for some reason the multiselects components returns two error items for one input, first doesnt have scope but the second one has. Inputs on the form return one error item
          const errors = this.$validator.errors.items.sort((a, b) => a.scope > b.scope ? 1 : -1)
          let errorScope = errors[0].scope ? errors[0].scope : null
          if (errorScope === null) {
            errorScope = this.$validator.errors.items[1] && this.$validator.errors.items[1].scope ? this.$validator.errors.items[1].scope : null
          }

          if (errorScope !== null) {
            const pageIndex = Number(errorScope.replace('step', ''))
            this.currentStep = pageIndex - 1
            if (this.bulmaSteps && this.bulmaSteps.length > 0) {
              this.bulmaSteps[0].onGoToStep(this.currentStep)
            }
          }

          if (this.onValidationFailure) {
            this.onValidationFailure()
          }
          document.querySelectorAll('.header-collapsed').forEach((x) => x.classList.remove('header-collapsed'))

          this.$nextTick(() => { this.$goToFirstValidationError(this.$validator.errors.items) })
        }
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    this.checkDirty(next)
  }
}

export default mixin
